import { useState } from 'react'
import { useAuth } from '@/store/auth'
import { gateLogoutUrl } from '@/lib/oneLogin'
import { Button, Card, Input } from '@diwata/ironvale'

export function Settings() {
  const { conclaveUrl, assayUrl, assayApiKey, keeper, setConclaveUrl, setAssayUrl, setAssayApiKey, logout, gateOrigin } =
    useAuth()

  const [form, setForm] = useState({ conclaveUrl, assayUrl, assayApiKey })
  const [saved, setSaved] = useState(false)

  function save() {
    setConclaveUrl(form.conclaveUrl)
    setAssayUrl(form.assayUrl)
    setAssayApiKey(form.assayApiKey)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  async function signOut() {
    // End Conclave's OWN session first (clears conclave_session — the gate's
    // /logout only ends the gate's cookie, not ours), then bounce to the gate's
    // /logout so it's out of everything (one-logout-everywhere). No gate origin
    // known → just clear locally and reload.
    await logout()
    if (gateOrigin) {
      window.location.assign(gateLogoutUrl(gateOrigin, `${window.location.origin}/`))
      return
    }
    window.location.assign('/')
  }

  const field = (key: keyof typeof form, label: string, placeholder?: string) => (
    <div className="cp-field">
      <label className="cp-label">{label}</label>
      <Input
        value={form[key]}
        onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
        placeholder={placeholder}
      />
    </div>
  )

  const heading = (text: string, top = 0) => (
    <div
      style={{
        fontSize: 11,
        fontWeight: 600,
        color: 'var(--ae-color-text-muted)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginTop: top,
      }}
    >
      {text}
    </div>
  )

  return (
    <div style={{ maxWidth: 480 }}>
      <div className="cp-page-header">
        <div className="cp-page-title">Settings</div>
      </div>

      <Card>
        <div className="cp-form">
          {heading('Account')}
          <div style={{ fontSize: 13 }}>
            Signed in as <strong>{keeper?.email ?? '—'}</strong>
          </div>
          <Button style={{ alignSelf: 'flex-start' }} onClick={signOut}>
            Sign out
          </Button>

          {heading('Conclave', 12)}
          {field('conclaveUrl', 'Conclave URL', 'http://localhost:8002')}

          {heading('Assay', 12)}
          {field('assayUrl', 'Assay URL', 'http://localhost:8000')}
          {field('assayApiKey', 'Assay API Key')}

          <Button style={{ alignSelf: 'flex-start' }} onClick={save}>
            {saved ? 'Saved' : 'Save'}
          </Button>
        </div>
      </Card>
    </div>
  )
}
